import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import Div from '../Page/Div';
import { WPImage } from '../UI/WPImage';
import { gsap } from 'gsap';
const LicensesHeaderSection = ({ content, idx, allowOpen, }) => {
    const { title, details_1, details_2, image_1, image_2 } = content?.licensing_title ?? {};
    const [imageOpen1, setImageOpen1] = useState(false);
    const [imageOpen2, setImageOpen2] = useState(false);
    const delayedCallRef = useRef(null);
    const delayedCallRef2 = useRef(null);
    useEffect(() => {
        delayedCallRef.current = gsap.delayedCall(0.5, showImage1);
        delayedCallRef2.current = gsap.delayedCall(0.5, showImage2);
        return () => {
            if (delayedCallRef.current) {
                delayedCallRef.current.kill();
            }
            if (delayedCallRef2.current) {
                delayedCallRef2.current.kill();
            }
        };
    }, []);
    const showImage1 = () => {
        setImageOpen1(true);
    };
    const showImage2 = () => {
        setImageOpen2(true);
    };
    return (_jsxs("div", { className: "licenses-header-container", children: [_jsx("div", { className: "licenses-header-spacer-1" }), _jsxs("div", { className: "licenses-header-section", children: [_jsx(Div, { className: "licenses-header-title", delay: 0, children: title }), _jsx(Div, { className: "licenses-header-details", delay: 2, children: details_1 }), _jsx(Div, { className: `licenses-header-image${imageOpen1 ? ' open' : ''}`, delay: 0, noScale: true, children: _jsx("div", { className: "licenses-header-image-slider", children: _jsx("div", { className: "licenses-header-image-wrapper", children: _jsx(WPImage, { id: image_1 }) }) }) })] }), _jsx("div", { className: "licenses-header-spacer-2" }), _jsxs("div", { className: "licenses-header-section bottom", children: [_jsx(Div, { className: "licenses-header-details", delay: 3, children: details_2 }), _jsx(Div, { className: `licenses-header-image${imageOpen2 ? ' open' : ''}`, delay: 0, noScale: true, children: _jsx("div", { className: "licenses-header-image-slider", children: _jsx("div", { className: "licenses-header-image-wrapper", children: _jsx(WPImage, { id: image_2 }) }) }) })] })] }));
};
export default LicensesHeaderSection;
